export enum EEmploymentType {
  Doctor = '0',
  Nurse = '1',
  Other = '2',
}
